// import React from 'react'
// import {
//     Sparkles, ArrowRight,
//     ChevronRight,
//     Zap,
//     Calendar,
//     PlusCircle,
//     CheckCircle2,
//     Bell,
//     Timer,
//     X,
//     Command,
//     Clock
// } from 'lucide-react';
// import { Button } from './Button';
// import { cn } from "../../assets/libs/utils"
// import { useState, useEffect, useRef } from "react";
// import { motion, AnimatePresence } from "motion/react";
// import { fireConfetti } from './fireConfetti';
// import confetti from 'canvas-confetti';
// import QuickActionsModal from './QuickActionsModal';
// import { toast } from 'react-toastify';
// import CurrentlyWorkingModal from './CurrentlyWorkingModal';
// import CheckInBurstOverlay from './CheckInBurstOverlay';

// const SUGGESTED_ACTIONS = [
//     {
//         id: "1",
//         icon: PlusCircle,
//         label: "Create Task",
//         description: "New project item",
//         // Default styling (Monochrome)
//         defaultColor: "text-slate-500",
//         defaultBg: "bg-white",
//         defaultBorder: "border-slate-200",
//         // Hover styling (Blue)
//         hoverColor: "group-hover:text-blue-600",
//         hoverBg: "group-hover:bg-blue-50",
//         hoverBorder: "group-hover:border-blue-200",
//         hoverIconBg: "group-hover:bg-white"
//     },
//     {
//         id: "2",
//         icon: Calendar,
//         label: "New Event",
//         description: "Schedule meeting",
//         // Default styling (Monochrome)
//         defaultColor: "text-slate-500",
//         defaultBg: "bg-white",
//         defaultBorder: "border-slate-200",
//         // Hover styling (Purple)
//         hoverColor: "group-hover:text-purple-600",
//         hoverBg: "group-hover:bg-purple-50",
//         hoverBorder: "group-hover:border-purple-200",
//         hoverIconBg: "group-hover:bg-white"
//     },
//     {
//         id: "3",
//         icon: Bell,
//         label: "Set Reminder",
//         description: "Notify me later",
//         // Default styling (Monochrome)
//         defaultColor: "text-slate-500",
//         defaultBg: "bg-white",
//         defaultBorder: "border-slate-200",
//         // Hover styling (Amber)
//         hoverColor: "group-hover:text-amber-600",
//         hoverBg: "group-hover:bg-amber-50",
//         hoverBorder: "group-hover:border-amber-200",
//         hoverIconBg: "group-hover:bg-white"
//     },
//     {
//         id: "4",
//         icon: Timer,
//         label: "Time Sheet",
//         description: "Clock In/Out",
//         // Default styling (Emerald - Always colored as requested)
//         defaultColor: "text-emerald-600",
//         defaultBg: "bg-emerald-50",
//         defaultBorder: "border-emerald-200",
//         // Hover styling (Emerald stronger)
//         hoverColor: "group-hover:text-emerald-700",
//         hoverBg: "group-hover:bg-emerald-100",
//         hoverBorder: "group-hover:border-emerald-300",
//         hoverIconBg: "group-hover:bg-white"
//     },
// ];
// export default function CheckIn_CheckOut() {
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const [activeAction, setActiveAction] = useState(null);
//     const [completedActions, setCompletedActions] = useState([]);
//     const [isCheckedIn, setIsCheckedIn] = useState(false);
//     const [open, setOpen] = useState(false);
//     const [burst, setBurst] = useState(false);
//     const [workingOpen, setWorkingOpen] = useState(false);
//     const [checkInStartedAt, setCheckInStartedAt] = useState(null); // null = not checked in
//     const [elapsedSec, setElapsedSec] = useState(0);
//     const [mode, setMode] = useState("idle"); // idle | working | break | done
//     const [checkInAt, setCheckInAt] = useState(null);
//     const [breakAt, setBreakAt] = useState(null);
//     const [totalBreakMs, setTotalBreakMs] = useState(0);
//     const [checkOutAt, setCheckOutAt] = useState(null);
//     const [breakCount, setBreakCount] = useState(0);
//     const [nowTs, setNowTs] = useState(Date.now());
//     const [breakOpen, setBreakOpen] = useState(false);
//     const [doneOpen, setDoneOpen] = useState(false);
//     const containerRef = useRef(null);

//     // Handle action selection
//     // const handleAction = (action) => {
//     //     setActiveAction(action.id);

//     //     // Simulate processing
//     //     setTimeout(() => {
//     //         setActiveAction(null);

//     //         fireConfetti()
//     //         let finalLabel = action.label;
//     //         if (action.id === "4") {
//     //             finalLabel = isCheckedIn ? "Checked Out Successfully" : "Checked In Successfully";
//     //             setIsCheckedIn(!isCheckedIn);
//     //         } else {
//     //             finalLabel = `${action.label} Created`;
//     //             toast.success(finalLabel)

//     //         }

//     //         // setCompletedActions(prev => [{ id: action.id + Date.now(), label: finalLabel, timestamp: Date.now() }, ...prev].slice(0, 3));

//     //         // Close menu after action
//     //         setIsMenuOpen(false);

//     //     }, 600);
//     // };
//     useEffect(() => {
//         if (mode === "idle") return;
//         const t = setInterval(() => setNowTs(Date.now()), 1000);
//         return () => clearInterval(t);
//     }, [mode]);
//     const totalSec = checkInAt ? Math.floor((nowTs - checkInAt) / 1000) : 0;
//     const runningBreakMs = breakAt ? nowTs - breakAt : 0;
//     const breakSec = Math.floor((totalBreakMs + runningBreakMs) / 1000);
//     const workSec = Math.max(0, totalSec - breakSec);

//     const formatDuration = (s) => {
//         if (s < 60) return `${s}s`;
//         const m = Math.floor(s / 60);
//         const r = s % 60;
//         return `${m}m ${r}s`;
//     };
//     useEffect(() => {
//         if (!checkInStartedAt) {
//             setElapsedSec(0);
//             return;
//         }

//         const t = setInterval(() => {
//             setElapsedSec(Math.floor((Date.now() - checkInStartedAt) / 1000));
//         }, 1000);

//         return () => clearInterval(t);
//     }, [checkInStartedAt]);
//     const startCheckIn = () => {
//         runBurst();
//         const ts = Date.now();

//         setCheckInAt(ts);
//         setBreakAt(null);
//         setTotalBreakMs(0);
//         setBreakCount(0);
//         setCheckOutAt(null);

//         setMode("working");
//         setWorkingOpen(true);
//         toast.success("Checked In Successfully");
//     };
//     const openTimeSheet = () => {
//         if (mode === "working") setWorkingOpen(true);
//         if (mode === "break") setBreakOpen(true);
//         if (mode === "done") setDoneOpen(true);
//     };
//     const startBreak = () => {
//         if (mode !== "working") return;
//         runBurst();

//         setBreakAt(Date.now());
//         setBreakCount((c) => c + 1);
//         setMode("break");

//         setWorkingOpen(false);
//         setBreakOpen(true);
//     };
//     const resumeWork = () => {
//         if (mode !== "break" || !breakAt) return;
//         runBurst();

//         const delta = Date.now() - breakAt;
//         setTotalBreakMs((ms) => ms + delta);
//         setBreakAt(null);
//         setMode("working");

//         setBreakOpen(false);
//         setWorkingOpen(true);
//     };
//     const runBurst = () => {
//         setBurst(true);
//         fireConfetti();
//         setTimeout(() => setBurst(false), 900);
//     };
//     const handleTimeSheetToggle = () => {
//         runBurst();

//         if (!isCheckedIn) {
//             setCheckInStartedAt(Date.now());
//             // setIsCheckedIn(true);
//             setWorkingOpen(true);              // ✅ SS-5 open
//             toast.success("Checked In Successfully");
//         } else {
//             // setIsCheckedIn(false);
//             setCheckInStartedAt(null);
//             setWorkingOpen(false);             // ✅ SS-5 close
//             toast.info("Checked Out Successfully");
//         }

//         setIsMenuOpen(false);
//     };
//     const handleAction = (action) => {
//         setActiveAction(action.id);

//         setTimeout(() => {
//             setActiveAction(null);

//             if (action.id === "4") {
//                 handleTimeSheetToggle(); // ✅ check-in/out flow
//                 return;
//             }

//             // other actions
//             fireConfetti();
//             const finalLabel = `${action.label} Created`;
//             toast.success(finalLabel);

//             setIsMenuOpen(false);
//         }, 600);
//     };
//     // Click outside to close
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (containerRef.current && !containerRef.current.contains(event.target)) {
//                 setIsMenuOpen(false);
//             }
//         };

//         if (isMenuOpen) {
//             document.addEventListener("mousedown", handleClickOutside);
//         }
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [isMenuOpen]);
//     return (
//         <div>
//             <main className="flex-1 container mx-auto px-6 flex flex-row items-center gap-16 pt-16 md:pt-24 pb-32">
//                 <div className='flex-1 flex-col gap-4 items-center'>
//                     {/* Floating Badge */}
//                     {/* <motion.div
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         className="mb-8 inline-flex items-center rounded-full border border-blue-100 bg-blue-50/50 px-3 py-1 text-xs font-medium text-blue-800 backdrop-blur-sm"
//                     >
//                         <Sparkles className="mr-2 h-3 w-3 text-blue-600" />
//                         Introducing Smart Actions
//                     </motion.div> */}

//                     {/* Hero Text */}
//                     <div className="text-center max-w-4xl mx-auto mb-12 space-y-6">
//                         <motion.h1
//                             initial={{ opacity: 0, y: 20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: 0.1 }}
//                             className="text-[55px] font-bold text-slate-900 font-sans"
//                         >
//                             Get More Done.
//                             <br />
//                             <span className="text-[#093A5B] after:absolute after:end-0  after:start-0  after:bottom-1 after:lg:h-3 after:h-2 after:w-auto after:rounded-xl after:bg-[#093A5B]/30 relative">Click Less.</span>
//                         </motion.h1>

//                         <motion.p
//                             initial={{ opacity: 0, y: 20 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: 0.2 }}
//                             className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed"
//                         >
//                             Access your most common actions instantly. Create tasks, schedule events, set reminders, and track your time — all from one convenient place.
//                             on the right side we'll have this
//                         </motion.p>
//                     </div>
//                 </div>
//                 <div className='flex-1 flex-col gap-5 justify-center items-center'>
//                     {/* INTERACTIVE COMPONENT: The "Action Bar" */}
//                     <div className="w-full max-w-md relative z-10 flex flex-col justify-center items-center  h-[320px]">

//                         {/* Success Notifications (Floating up) */}
//                         <div className="absolute bottom-full left-0 right-0 mb-8 flex flex-col-reverse items-center gap-2 pointer-events-none h-40 justify-start z-0">
//                             <AnimatePresence>
//                                 {completedActions.map((action) => (
//                                     <motion.div
//                                         key={action.id}
//                                         initial={{ opacity: 0, y: 20, scale: 0.9 }}
//                                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                                         exit={{ opacity: 0, y: -20, scale: 0.95 }}
//                                         transition={{ duration: 0.4 }}
//                                         className="flex items-center gap-3 bg-emerald-50 border border-emerald-100 px-4 py-2.5 rounded-full shadow-lg shadow-emerald-500/10 backdrop-blur-md"
//                                     >
//                                         <div className="h-5 w-5 rounded-full bg-emerald-500 flex items-center justify-center">
//                                             <CheckCircle2 className="h-3.5 w-3.5 text-white" />
//                                         </div>
//                                         <span className="text-sm font-medium text-emerald-900">{action.label}</span>
//                                     </motion.div>
//                                 ))}
//                             </AnimatePresence>
//                         </div>

//                         {/* Animated Container for Button <-> Menu transition */}
//                         <div ref={containerRef} className="relative w-full flex justify-center perspective-[1000px]">
//                             <AnimatePresence mode="wait">
//                                 {!isMenuOpen ? (
//                                     <motion.button
//                                         key="trigger-button"
//                                         initial={{ opacity: 0, y: 20, scale: 0.9 }}
//                                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                                         exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
//                                         whileHover={{ scale: 1.02 }}
//                                         whileTap={{ scale: 0.98 }}
//                                         onClick={() => setIsMenuOpen(true)}
//                                         className="group relative flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-xl shadow-blue-900/10 border border-slate-200 text-slate-600 hover:text-[#093A5B] hover:border-blue-200 transition-all z-20"
//                                     >
//                                         <div className="bg-slate-100 p-2 rounded-full group-hover:bg-blue-50 transition-colors">
//                                             <Zap className="h-5 w-5 text-slate-500 group-hover:text-[#093A5B] fill-current transition-colors" />
//                                         </div>
//                                         {/* <span className="text-lg font-medium">Smart Actions</span> */}
//                                         {/* <span className="relative text-lg font-medium after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#093A5B] after:transition-all after:duration-500 group-hover:after:w-full">
//                                             Smart Actions
//                                         </span> */}
//                                         <span
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 setTimeout(() => {

//                                                     fireConfetti();
//                                                 }, 600)
//                                             }}
//                                             className="relative text-lg font-medium cursor-pointer select-none
//              after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#093A5B]
//              after:transition-all after:duration-500 group-hover:after:w-full"
//                                         >
//                                             Smart Actions
//                                         </span>
//                                         <div className="flex items-center gap-1 bg-slate-100 px-2 py-1 rounded text-[10px] font-bold text-slate-400 border border-slate-200 ml-2">
//                                             <Command className="h-3 w-3" />
//                                             <span>K</span>
//                                         </div>

//                                         {/* Glow effect */}
//                                         <div className="absolute inset-0 rounded-full bg-blue-400/5 blur-xl -z-10 group-hover:bg-blue-400/10 transition-all" />
//                                     </motion.button>
//                                 ) : (
//                                     <motion.div
//                                         key="command-menu"
//                                         initial={{ opacity: 0 }}
//                                         animate={{ opacity: 1 }}
//                                         exit={{ opacity: 0, transition: { duration: 0.2 } }}
//                                         className="w-full relative z-20"
//                                     >
//                                         {/* Close Button - Floating Outside Top Right */}
//                                         <div className="absolute -top-12 -right-4 z-30">
//                                             <motion.button
//                                                 initial={{ opacity: 0, scale: 0 }}
//                                                 animate={{ opacity: 1, scale: 1 }}
//                                                 transition={{ delay: 0.2 }}
//                                                 onClick={(e) => { e.stopPropagation(); setIsMenuOpen(false); }}
//                                                 className="h-8 w-8 rounded-full bg-white/80 backdrop-blur border border-slate-200 shadow-sm text-slate-400 hover:text-red-500 hover:bg-red-50 flex items-center justify-center transition-colors"
//                                             >
//                                                 <X className="h-4 w-4" />
//                                             </motion.button>
//                                         </div>

//                                         {/* Vertical Actions List - NO Container Frame */}
//                                         <div className="flex flex-col gap-3">
//                                             {SUGGESTED_ACTIONS.map((action, i) => (
//                                                 <motion.button
//                                                     key={action.id}
//                                                     onClick={() => handleAction(action)}
//                                                     disabled={!!activeAction}
//                                                     initial={{ opacity: 0, y: 20 }}
//                                                     animate={{ opacity: 1, y: 0 }}
//                                                     exit={{ opacity: 0, y: 10 }}
//                                                     transition={{ delay: i * 0.05, type: "spring", stiffness: 300, damping: 24 }}
//                                                     whileHover={{ scale: 1.02 }}
//                                                     whileTap={{ scale: 0.98 }}
//                                                     className={cn(
//                                                         "flex items-center gap-5 px-5 py-4 rounded-full border transition-all w-full relative overflow-hidden group text-left shadow-sm hover:shadow-lg hover:shadow-blue-900/5 bg-white",
//                                                         action.defaultBorder,
//                                                         action.hoverBorder,
//                                                         action.defaultBg, // Apply Check-in Color here
//                                                         action.hoverBg
//                                                     )}
//                                                 >
//                                                     {/* Icon Container */}
//                                                     <div className={cn(
//                                                         "h-10 w-10 min-w-[2.5rem] rounded-full flex items-center justify-center shadow-sm ring-1 ring-black/5 transition-colors duration-300",
//                                                         // Default State
//                                                         "bg-slate-50",
//                                                         // Hover State
//                                                         action.hoverIconBg
//                                                     )}>
//                                                         <action.icon className={cn(
//                                                             "h-5 w-5 transition-colors duration-300",
//                                                             action.defaultColor,
//                                                             action.hoverColor
//                                                         )} />
//                                                     </div>

//                                                     {/* Text Content */}
//                                                     <div className="flex-1 flex flex-col items-start justify-center">
//                                                         <span className={cn(
//                                                             "text-base font-bold transition-colors duration-300",
//                                                             action.id === "4" ? "text-emerald-800" : "text-slate-700",
//                                                             action.hoverColor
//                                                         )}
//                                                             onClick={(e) => {
//                                                                 // ✅ only for Time Sheet and only when it shows "Check Out"
//                                                                 if (action.id !== "4" || !isCheckedIn) return;

//                                                                 e.stopPropagation();       // ✅ outer button click prevent
//                                                                 handleTimeSheetToggle();   // ✅ burst + close SS-5 + checkout
//                                                             }}>

//                                                             {/* {action.id === "4" && isCheckedIn ? "Check Out" : action.label} */}
//                                                             {/* <span className="text-base font-bold">
//                                                                 {action.id === "4"
//                                                                     ? (checkInStartedAt ? "Currently Working" : "Check In")
//                                                                     : action.label}
//                                                             </span> */}
//                                                             {action.id === "4" ? (
//                                                                 <>
//                                                                     <span className="text-base font-bold">
//                                                                         {mode === "idle" ? "Check In" : mode === "working" ? "Currently Working" : mode === "break" ? "On Break" : "All Done"}
//                                                                     </span>
//                                                                     <span className="text-sm font-medium text-emerald-600/70">
//                                                                         {mode === "idle" ? "0s" : mode === "working" ? formatDuration(workSec) : mode === "break" ? formatDuration(breakSec) : `${formatDuration(workSec)}`}
//                                                                     </span>
//                                                                 </>
//                                                             ) : (
//                                                                 <>
//                                                                     <span className="text-base font-bold">{action.label}</span>
//                                                                     <span className="text-sm font-medium text-slate-400">{action.description}</span>
//                                                                 </>
//                                                             )}
//                                                         </span>
//                                                         <span className={cn(
//                                                             "text-sm font-medium transition-colors duration-300",
//                                                             action.id === "4" ? "text-emerald-600/70" : "text-slate-400",
//                                                             "group-hover:text-current/70"
//                                                         )}>
//                                                             {action.id === "4"
//                                                                 ? (checkInStartedAt ? formatDuration(elapsedSec) : "0s")
//                                                                 : action.description}
//                                                         </span>
//                                                     </div>

//                                                     <div className="opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-2 group-hover:translate-x-0">
//                                                         <ChevronRight className={cn("h-5 w-5", action.hoverColor)} />
//                                                     </div>

//                                                     {/* Loading State Overlay (per button) */}
//                                                     {activeAction === action.id && (
//                                                         <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] flex items-center justify-center z-10">
//                                                             <div className="h-6 w-6 border-2 border-[#093A5B] border-t-transparent rounded-full animate-spin" />
//                                                         </div>
//                                                     )}
//                                                 </motion.button>
//                                             ))}
//                                         </div>
//                                     </motion.div>
//                                 )}
//                             </AnimatePresence>
//                         </div>
//                     </div>

//                     {/* Standard CTAs below */}
//                     {/* <motion.div
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         transition={{ delay: 0.6 }}
//                         className="mt-8 flex w-full flex-col items-center justify-center gap-4 sm:flex-row font-sans"
//                     >
//                         <Button size="lg" className="h-12 px-8 shadow-xl shadow-blue-900/10 bg-[#093A5B] hover:bg-[#0B4468]">
//                             Start free trial
//                             <ArrowRight className="ml-2 h-4 w-4" />
//                         </Button>
//                         <div className="text-sm text-slate-500 flex items-center gap-2">
//                             <CheckCircle2 className="h-4 w-4 text-green-500" />
//                             No credit card required
//                         </div>
//                     </motion.div> */}
//                 </div>
//             </main>
//             <motion.button
//                 type="button"
//                 // onClick={onClick}
//                 onClick={() => setOpen(true)}
//                 className="fixed bottom-8 right-8 z-50 group outline-none"
//                 initial={{ opacity: 0, y: 12 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 whileHover={{ scale: 1.06 }}
//                 whileTap={{ scale: 0.95 }}
//                 transition={{ type: "spring", stiffness: 300, damping: 22 }}
//                 aria-label="Open time actions"
//             >
//                 {/* Glow blur */}
//                 <div className="absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 blur-2xl opacity-60 transition-opacity duration-300 group-hover:opacity-100" />

//                 {/* Main button */}
//                 <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 shadow-2xl shadow-cyan-500/50 flex items-center justify-center border-4 border-white/20">
//                     <Clock className="w-8 h-8 text-white" />
//                 </div>

//                 {/* Animated ring (subtle) */}
//                 <span className="pointer-events-none absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 opacity-0 group-hover:opacity-30 transition-opacity duration-300" />

//                 {/* Optional pulse ring */}
//                 <span className="pointer-events-none absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 opacity-25 animate-ping" />
//             </motion.button>
//             <QuickActionsModal
//                 open={open}
//                 onClose={() => setOpen(false)}
//                 onAction={(item) => {
//                     console.log("Clicked:", item.id);
//                     setOpen(false);
//                     if (item.id === "checkin") {
//                         if (mode === "idle") startCheckIn();
//                         else openTimeSheet();
//                         return;
//                     }
//                     fireConfetti();
//                     toast.success(`${item.label} Done`);
//                 }}
//             />

//             <CurrentlyWorkingModal
//                 open={workingOpen}
//                 onClose={() => setWorkingOpen(false)}
//                 checkInAt={checkInAt}
//                 workSec={workSec}
//                 onBreak={startBreak}
//                 onCheckOut={checkOut}
//             />
//             <OnBreakModal
//                 open={breakOpen}
//                 onClose={() => setBreakOpen(false)}
//                 breakAt={breakAt}
//                 breakSec={breakSec}
//                 workSec={workSec}
//                 onResume={resumeWork}
//                 onCheckOut={checkOut}
//             />
//             <AllDoneModal
//                 open={doneOpen}
//                 onClose={resetDay}          // ✅ closing = new day start
//                 onUndo={undoCheckout}
//                 checkInAt={checkInAt}
//                 checkOutAt={checkOutAt}
//                 breakCount={breakCount}
//                 breakSec={breakSec}
//                 workSec={workSec}
//             />
//             <CheckInBurstOverlay show={burst} />

//         </div>
//     )
// }

import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import {
  ChevronRight,
  Zap,
  Calendar,
  PlusCircle,
  CheckCircle2,
  Bell,
  Timer,
  X,
  Command,
  Clock,
} from "lucide-react";
import { cn } from "../../assets/libs/utils";
import { toast } from "react-toastify";

import { fireConfetti } from "./fireConfetti";
import QuickActionsModal from "./QuickActionsModal";
import CurrentlyWorkingModal from "./CurrentlyWorkingModal";
import OnBreakModal from "./OnBreakModal";
import AllDoneModal from "./AllDoneModal";
import CheckInBurstOverlay from "./CheckInBurstOverlay";

const ACTIONS = [
  {
    id: "1",
    icon: PlusCircle,
    label: "Create Task",
    labelAfter: "Task created successfully",
    description: "Assign & track instantly",
    defaultColor: "text-slate-500",
    hoverColor: "group-hover:text-blue-600",
    hoverBg: "group-hover:bg-blue-50",
    hoverBorder: "group-hover:border-blue-200",
    border: "border-slate-200",
    bg: "bg-white",
  },
  {
    id: "2",
    icon: Calendar,
    label: "New Event",
    labelAfter: "Great ! Event added",
    description: "Block team time",
    defaultColor: "text-slate-500",
    hoverColor: "group-hover:text-purple-600",
    hoverBg: "group-hover:bg-purple-50",
    hoverBorder: "group-hover:border-purple-200",
    border: "border-slate-200",
    bg: "bg-white",
  },
  {
    id: "3",
    icon: Bell,
    label: "Set Reminder",
    labelAfter: "Reminder Scheduled",
    description: "Stay ahead of due dates",
    defaultColor: "text-slate-500",
    hoverColor: "group-hover:text-amber-600",
    hoverBg: "group-hover:bg-amber-50",
    hoverBorder: "group-hover:border-amber-200",
    border: "border-slate-200",
    bg: "bg-white",
  },
  {
    id: "4",
    icon: Timer,
    label: "Time Sheet",
    labelAfter: "You're all set for the day",
    description: "Start your day",
    defaultColor: "text-emerald-600",
    hoverColor: "group-hover:text-emerald-700",
    hoverBg: "group-hover:bg-emerald-100",
    hoverBorder: "group-hover:border-emerald-300",
    border: "border-emerald-200",
    bg: "bg-emerald-50",
  },
];

export default function CheckIn_CheckOut() {
  const containerRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeAction, setActiveAction] = useState(null);
  const [completedActions, setCompletedActions] = useState([]);

  // floating quick actions
  const [quickOpen, setQuickOpen] = useState(false);

  // burst overlay
  const [burst, setBurst] = useState(false);

  // modal states
  const [workingOpen, setWorkingOpen] = useState(false);
  const [breakOpen, setBreakOpen] = useState(false);
  const [doneOpen, setDoneOpen] = useState(false);

  // ✅ State machine: idle | working | break | done
  const [mode, setMode] = useState("idle");
  const [checkInAt, setCheckInAt] = useState(null);
  const [breakAt, setBreakAt] = useState(null);
  const [totalBreakMs, setTotalBreakMs] = useState(0);
  const [checkOutAt, setCheckOutAt] = useState(null);
  const [breakCount, setBreakCount] = useState(0);

  // time tick (no localStorage => F5 resets naturally)
  const [nowTs, setNowTs] = useState(Date.now());

  useEffect(() => {
    // if (mode === "idle") return;
    if (mode !== "working" && mode !== "break") return;
    const t = setInterval(() => setNowTs(Date.now()), 1000);
    return () => clearInterval(t);
  }, [mode]);

  // derived times
  const totalSec = checkInAt ? Math.floor((nowTs - checkInAt) / 1000) : 0;
  const runningBreakMs = breakAt ? nowTs - breakAt : 0;
  const breakSec = Math.floor((totalBreakMs + runningBreakMs) / 1000);
  const workSec = Math.max(0, totalSec - breakSec);

  const formatDuration = (s) => {
    if (s < 60) return `${s}s`;
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}m ${r}s`;
  };

  const runBurst = () => {
    setBurst(true);
    fireConfetti();
    setTimeout(() => setBurst(false), 900);
  };

  // ✅ Figma behavior: start only when idle
  const startCheckIn = () => {
    runBurst();
    const ts = Date.now();

    setCheckInAt(ts);
    setBreakAt(null);
    setTotalBreakMs(0);
    setBreakCount(0);
    setCheckOutAt(null);

    setMode("working");
    setWorkingOpen(true);
    toast.success("You're all set for the day");
    // console.log("WORK sec", workSec);
  };

  // ✅ if already started, open correct modal (no restart)
  const openTimeSheet = () => {
    if (mode === "working") setWorkingOpen(true);
    if (mode === "break") setBreakOpen(true);
    if (mode === "done") setDoneOpen(true);
  };

  const startBreak = () => {
    if (mode !== "working") return;
    runBurst();

    setBreakAt(Date.now());
    setBreakCount((c) => c + 1);
    setMode("break");

    setWorkingOpen(false);
    setBreakOpen(true);
  };

  const resumeWork = () => {
    if (mode !== "break" || !breakAt) return;
    runBurst();

    const delta = Date.now() - breakAt;
    setTotalBreakMs((ms) => ms + delta);
    setBreakAt(null);

    setMode("working");
    setBreakOpen(false);
    setWorkingOpen(true);
  };

  const checkOut = () => {
    if (mode === "idle" || !checkInAt) return;

    runBurst();

    // if checkout while break, finalize break time
    if (mode === "break" && breakAt) {
      const delta = Date.now() - breakAt;
      setTotalBreakMs((ms) => ms + delta);
      setBreakAt(null);
    }

    setCheckOutAt(Date.now());
    setMode("done");

    setWorkingOpen(false);
    setBreakOpen(false);
    setDoneOpen(true);

    toast.success("Day successfully completed");
  };

  const undoCheckout = () => {
    if (mode !== "done") return;

    runBurst();
    setCheckOutAt(null);
    setMode("working");

    setDoneOpen(false);
    setWorkingOpen(true);

    toast.info("Check-out undone");
  };

  const resetDay = () => {
    setMode("idle");
    setCheckInAt(null);
    setBreakAt(null);
    setTotalBreakMs(0);
    setCheckOutAt(null);
    setBreakCount(0);

    setWorkingOpen(false);
    setBreakOpen(false);
    setDoneOpen(false);
  };

  // main action click
  const handleAction = (action) => {
    setActiveAction(action.id);

    setTimeout(() => {
      setActiveAction(null);

      // ✅ Time Sheet / Check-in behavior
      if (action.id === "4") {
        if (mode === "idle") startCheckIn();
        else openTimeSheet();
        setIsMenuOpen(false);
        return;
      }

      // Other actions
      runBurst();
      const finalLabel = `${action.labelAfter}`;
      //   console.log("What the sassa",finalLabel)
      // setCompletedActions((prev) =>
      //     [{ id: action.id + Date.now(), label: finalLabel }, ...prev].slice(0, 3)
      // );
      toast.success(finalLabel);
      setIsMenuOpen(false);
    }, 250);
  };

  // close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  // dynamic UI for Time Sheet row
  const timeTitle =
    mode === "idle"
      ? "Check In"
      : mode === "working"
        ? "Currently Working"
        : mode === "break"
          ? "On Break"
          : "All Done";

  const timeSub =
    mode === "idle"
      ? "0s"
      : mode === "working"
        ? formatDuration(workSec)
        : mode === "break"
          ? formatDuration(breakSec)
          : formatDuration(workSec);

  // optional: change color for time row based on mode
  const timeRowBg =
    mode === "break"
      ? "bg-amber-50 border-amber-200"
      : mode === "done"
        ? "bg-emerald-50 border-emerald-200"
        : "bg-emerald-50 border-emerald-200";

  return (
    <div className="">
      {/* flex-1 container mx-auto px-6 flex flex-row items-center gap-16 md:pt-24 pb-32 */}
      <main id="quick-action-section" className="Chech_In_Out_Class ">
        {/* LEFT COPY */}
        <div className="flex-col gap-4 items-center">
          <div className="text-center max-w-4xl mx-auto mb-12 space-y-6 ">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="Chech_In_Out_Class_Heading LineCss"
            >
              Get More Done.
              <br />
              <span className="text-[#093A5B] after:absolute after:end-0 after:start-0 after:bottom-1 after:lg:h-3 after:h-2 after:w-auto after:rounded-xl after:bg-[#093A5B]/30 relative">
                Click Less.
              </span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="Chech_In_Out_Class_Para"
            >
              Access your most common actions instantly. Create tasks, schedule
              events, set reminders, and track your time — all from one
              convenient place.
            </motion.p>
          </div>
        </div>

        {/* RIGHT INTERACTIVE */}
        <div className="flex-col gap-5 justify-center items-center">
          <div className="Chech_In_Out_Class_Button">
            {/* mini toasts on top of list */}
            <div className="absolute bottom-full left-0 right-0 mb-8 flex flex-col-reverse items-center gap-2 pointer-events-none h-40 justify-start z-0">
              <AnimatePresence>
                {completedActions.map((a) => (
                  <motion.div
                    key={a.id}
                    initial={{ opacity: 0, y: 18, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -18, scale: 0.96 }}
                    transition={{ duration: 0.35 }}
                    className="flex items-center gap-3 bg-emerald-50 border border-emerald-100 px-4 py-2.5 rounded-full shadow-lg shadow-emerald-500/10 backdrop-blur-md"
                  >
                    <div className="h-5 w-5 rounded-full bg-emerald-500 flex items-center justify-center">
                      <CheckCircle2 className="h-3.5 w-3.5 text-white" />
                    </div>
                    <span className="text-sm font-medium text-emerald-900">
                      {a.label}
                    </span>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            <div
              ref={containerRef}
              className="relative w-full flex justify-center perspective-[1000px]"
            >
              <AnimatePresence mode="wait">
                {!isMenuOpen ? (
                  <motion.button
                    key="trigger-button"
                    initial={{ opacity: 0, y: 18, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{
                      opacity: 0,
                      scale: 0.95,
                      transition: { duration: 0.2 },
                    }}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => setIsMenuOpen(true)}
                    className="group relative flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-xl shadow-blue-900/10 border border-slate-200 text-slate-600 hover:text-[#093A5B] hover:border-blue-200 transition-all z-20"
                  >
                    <div className="bg-slate-100 p-2 rounded-full group-hover:bg-blue-50 transition-colors">
                      <Zap className="h-5 w-5 text-slate-500 group-hover:text-[#093A5B] transition-colors" />
                    </div>

                    <span
                      className="relative text-lg font-medium select-none font-semibold
                      after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#093A5B]
                      after:transition-all after:duration-500 group-hover:after:w-full"
                    >
                      Smart Actions
                    </span>

                    {/* <div className="flex items-center gap-1 bg-slate-100 px-2 py-1 rounded text-[10px] font-bold text-slate-400 border border-slate-200 ml-2">
                      <Command className="h-3 w-3" />
                      <span>K</span>
                    </div> */}

                    <div className="absolute inset-0 rounded-full bg-blue-400/5 blur-xl -z-10 group-hover:bg-blue-400/10 transition-all" />
                  </motion.button>
                ) : (
                  <motion.div
                    key="command-menu"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.2 } }}
                    className="w-full relative z-20 mt-16"
                  >
                    <div className="absolute -top-12 -right-4 z-30">
                      <motion.button
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.1 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsMenuOpen(false);
                        }}
                        className="h-8 w-8 rounded-full bg-white/80 backdrop-blur border border-slate-200 shadow-sm text-slate-400 hover:text-red-500 hover:bg-red-50 flex items-center justify-center transition-colors"
                      >
                        <X className="h-4 w-4" />
                      </motion.button>
                    </div>

                    <div className="flex flex-col gap-3">
                      {ACTIONS.map((action, i) => {
                        const isTime = action.id === "4";
                        const timeClass = isTime ? timeRowBg : "";

                        return (
                          <motion.button
                            key={action.id}
                            onClick={() => handleAction(action)}
                            disabled={!!activeAction}
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 10 }}
                            transition={{
                              delay: i * 0.05,
                              type: "spring",
                              stiffness: 300,
                              damping: 24,
                            }}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            className={cn(
                              "flex items-center gap-5 px-5 py-4 rounded-full border transition-all w-full relative overflow-hidden group text-left shadow-sm hover:shadow-lg hover:shadow-blue-900/5 bg-white",
                              action.border,
                              action.hoverBorder,
                              action.bg,
                              action.hoverBg,
                              timeClass,
                            )}
                          >
                            <div
                              className={cn(
                                "h-10 w-10 min-w-[2.5rem] rounded-full flex items-center justify-center shadow-sm ring-1 ring-black/5 transition-colors duration-300",
                                "bg-slate-50",
                                "group-hover:bg-white",
                              )}
                            >
                              <action.icon
                                className={cn(
                                  "h-5 w-5 transition-colors duration-300",
                                  isTime
                                    ? "text-emerald-600"
                                    : action.defaultColor,
                                  action.hoverColor,
                                )}
                              />
                            </div>

                            <div className="flex-1 flex flex-col items-start justify-center">
                              {isTime ? (
                                <>
                                  <span className="text-base font-bold text-emerald-800">
                                    {timeTitle}
                                  </span>
                                  <span className="text-emerald-600 text-[14px]">
                                    {action.description}
                                  </span>
                                  {/* {console.log("Time", timeSub)} */}

                                  {timeSub ? (
                                    ""
                                  ) : (
                                    <span className="text-sm font-medium text-emerald-600/70">
                                      {timeSub}
                                    </span>
                                  )}
                                </>
                              ) : (
                                <>
                                  <span
                                    className={cn(
                                      "text-base font-semibold text-slate-700 transition-colors duration-300",
                                      action.hoverColor,
                                    )}
                                  >
                                    {action.label}
                                  </span>
                                  <span className="text-sm font-medium text-slate-400 transition-colors duration-300 group-hover:text-current/70">
                                    {action.description}
                                  </span>
                                </>
                              )}
                            </div>

                            <div className="opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-2 group-hover:translate-x-0">
                              <ChevronRight
                                className={cn("h-5 w-5", action.hoverColor)}
                              />
                            </div>

                            {activeAction === action.id && (
                              <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] flex items-center justify-center z-10">
                                <div className="h-6 w-6 border-2 border-[#093A5B] border-t-transparent rounded-full animate-spin" />
                              </div>
                            )}
                          </motion.button>
                        );
                      })}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </main>

      {/* Floating clock button */}
      {/* <motion.button
                type="button"
                onClick={() => setQuickOpen(true)}
                className="fixed bottom-8 right-8 z-50 group outline-none"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.06 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                aria-label="Open quick actions"
            >
                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 blur-2xl opacity-60 transition-opacity duration-300 group-hover:opacity-100" />
                <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-cyan-500 to-blue-600 shadow-2xl shadow-cyan-500/50 flex items-center justify-center border-4 border-white/20">
                    <Clock className="w-8 h-8 text-white" />
                </div>
                <span className="pointer-events-none absolute inset-0 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 opacity-25 animate-ping" />
            </motion.button> */}

      {/* Quick actions modal */}
      <QuickActionsModal
        open={quickOpen}
        onClose={() => setQuickOpen(false)}
        onAction={(item) => {
          setQuickOpen(false);

          if (item.id === "checkin") {
            if (mode === "idle") startCheckIn();
            else openTimeSheet();
            return;
          }

          runBurst();
          toast.success(`${item.label} Done`);
        }}
      />

      {/* BURST overlay */}
      <CheckInBurstOverlay show={burst} />

      {/* Modals */}
      <CurrentlyWorkingModal
        open={workingOpen}
        onClose={() => setWorkingOpen(false)}
        checkInAt={checkInAt}
        workSec={workSec}
        onBreak={startBreak}
        onCheckOut={checkOut}
      />

      <OnBreakModal
        open={breakOpen}
        onClose={() => setBreakOpen(false)}
        breakAt={breakAt}
        breakSec={breakSec}
        workSec={workSec}
        onResume={resumeWork}
        onCheckOut={checkOut}
      />

      <AllDoneModal
        open={doneOpen}
        onClose={resetDay} // closing = new day start (F5 behavior)
        onUndo={undoCheckout}
        checkInAt={checkInAt}
        checkOutAt={checkOutAt}
        breakCount={breakCount}
        breakSec={breakSec}
        workSec={workSec}
      />
    </div>
  );
}
